import cn from 'classnames'
import React from 'react'

const HeroIntegrationVisual = ({ integrations = [], classes = '' }) => {
  return (
    <div className={cn('c-hero-integration-visual', classes)}>
      <div className="c-hero-integration-visual__container">
        {integrations.length > 0 &&
          integrations.map((item, index) => {
            if (index === integrations.length - 1) {
              const w = item.image.width
              const h = item.image.height
              const aspectRatio = w / h
              const imgProps = Math.floor(aspectRatio) <= 1 ? { width: 160 } : { width: '100%' }
              return (
                <div key={item.id} className="c-hero-integration-visual__integration">
                  <div className="c-hero-integration-visual__visual">
                    {item.image && (
                      <img
                        {...imgProps}
                        src={item.image.url}
                        alt={item.image.alt || item.image.title}
                      />
                    )}

                    <span className="c-hero-integration-visual__borders">
                      <span className="c-hero-integration-visual__border"></span>
                    </span>
                  </div>
                </div>
              )
            }
            return (
              <>
                <div key={item.id} className="c-hero-integration-visual__integration">
                  <div className="c-hero-integration-visual__visual">
                    <img
                      loading="lazy"
                      className="c-hero-integration-visual__image"
                      src={item.image}
                      alt={item.label}
                      title={item.label}
                    />

                    <span className="c-hero-integration-visual__borders">
                      <span className="c-hero-integration-visual__border"></span>
                    </span>
                  </div>
                </div>
                <div className="c-hero-integration-visual__separator"></div>
              </>
            )
          })}
      </div>
    </div>
  )
}

export default HeroIntegrationVisual
